import { useEffect } from 'react';

import { DOMAIN_EVENT_FEED_LOOKBACK_MS, domainEventsApi } from '#entities';
import { useAppDispatch, useAppSelector } from '#shared';

import type { AuthTokenGetter } from '#shared/api';

import {
  BACKFILL_ARG,
  runDomainEventHistoryBackfill,
} from './domainEventBackfill';

import type { RootState } from '#shared';

/** The unfiltered entry holds the 48 h lookback, and its row cap cut history off. */
export const selectHistoryBackfillDue = (state: RootState): boolean => {
  const entry =
    domainEventsApi.endpoints.getDomainEvents.select(BACKFILL_ARG)(state);

  return (
    entry.isSuccess &&
    entry.data?.capped === true &&
    (entry.originalArgs?.lookbackMs ?? 0) >= DOMAIN_EVENT_FEED_LOOKBACK_MS
  );
};

export const useDomainEventHistoryBackfill = (
  getToken: AuthTokenGetter,
): void => {
  const dispatch = useAppDispatch();
  const due = useAppSelector(selectHistoryBackfillDue);

  useEffect(() => {
    if (due) {
      void runDomainEventHistoryBackfill(dispatch, getToken);
    }
  }, [dispatch, due, getToken]);
};
